module.exports = __webpack_public_path__ + "31d6f73e935fae4e04c0042c260ddc55.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio6/08_6MCA-Another-Body.ogg
// module id = 799
// module chunks = 0